export default __webpack_public_path__ + "static/media/flaunt.58409310.png";